/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';
import type { ParcTenancyTenantDto } from './ParcTenancyTenantDto';
import {
    ParcTenancyTenantDtoFromJSON,
    ParcTenancyTenantDtoFromJSONTyped,
    ParcTenancyTenantDtoToJSON,
    ParcTenancyTenantDtoToJSONTyped,
} from './ParcTenancyTenantDto';

/**
 * 
 * @export
 * @interface ParcTenancyBienDto
 */
export interface ParcTenancyBienDto {
    /**
     * 
     * @type {string}
     * @memberof ParcTenancyBienDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParcTenancyBienDto
     */
    name: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof ParcTenancyBienDto
     */
    address?: AddressDto;
    /**
     * 
     * @type {number}
     * @memberof ParcTenancyBienDto
     */
    rentWithCharges: number;
    /**
     * Au moins un locataire valide — un bien non valide bloque la contractualisation GLI
     * @type {boolean}
     * @memberof ParcTenancyBienDto
     */
    isValid: boolean;
    /**
     * Dans la couverture effective (false = écarté par checkbox, réintégrable)
     * @type {boolean}
     * @memberof ParcTenancyBienDto
     */
    isIncluded?: boolean;
    /**
     * 
     * @type {Array<ParcTenancyTenantDto>}
     * @memberof ParcTenancyBienDto
     */
    tenants: Array<ParcTenancyTenantDto>;
}

/**
 * Check if a given object implements the ParcTenancyBienDto interface.
 */
export function instanceOfParcTenancyBienDto(value: object): value is ParcTenancyBienDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rentWithCharges' in value) || value['rentWithCharges'] === undefined) return false;
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    if (!('tenants' in value) || value['tenants'] === undefined) return false;
    return true;
}

export function ParcTenancyBienDtoFromJSON(json: any): ParcTenancyBienDto {
    return ParcTenancyBienDtoFromJSONTyped(json, false);
}

export function ParcTenancyBienDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcTenancyBienDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'rentWithCharges': json['rentWithCharges'],
        'isValid': json['isValid'],
        'isIncluded': json['isIncluded'] == null ? undefined : json['isIncluded'],
        'tenants': ((json['tenants'] as Array<any>).map(ParcTenancyTenantDtoFromJSON)),
    };
}

export function ParcTenancyBienDtoToJSON(json: any): ParcTenancyBienDto {
    return ParcTenancyBienDtoToJSONTyped(json, false);
}

export function ParcTenancyBienDtoToJSONTyped(value?: ParcTenancyBienDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': AddressDtoToJSON(value['address']),
        'rentWithCharges': value['rentWithCharges'],
        'isValid': value['isValid'],
        'isIncluded': value['isIncluded'],
        'tenants': ((value['tenants'] as Array<any>).map(ParcTenancyTenantDtoToJSON)),
    };
}

